import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"];
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultForm = {
  wineryIds: [],
  customTitle: "",
  isShowTurnover: false,
  isActive: false,
  valid: false
};
export default {
  name: "WineryDashboardFormModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    id: Number | null
  },
  data: function data() {
    return {
      dialog: false,
      isLoading: false,
      isAdding: false,
      regionIdForProducers: null,
      form: _objectSpread({}, defaultForm),
      dbSyncedDashboard: null,
      isWineryIdsFocused: false,
      isCustomTitleFocused: false,
      isUpdatingConfiguration: false,
      isUpdatingCustomTitle: false,
      isUpdatingActivationStatus: false,
      isDeletingDashboard: false,
      wineries: {
        isLoading: false,
        items: []
      },
      gettingRegions: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      formRules: formRules,
      vAutocompleteSearchValue: "",
      filterVAutocomplete: filterVAutocomplete,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isEditingDashboard: function isEditingDashboard() {
      return +this.id > 0;
    },
    isAnyFocused: function isAnyFocused() {
      return this.isWineryIdsFocused || this.isCustomTitleFocused;
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isAdding || this.isUpdatingConfiguration || this.isUpdatingCustomTitle || this.isUpdatingActivationStatus || this.isDeletingDashboard;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.getWineries();
            _this2.getRegions();
            if (!_this2.id) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return _this2.getDashboard();
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    getDashboard: function getDashboard() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response, result;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.isLoading = true;
              _this = _this3;
              _context2.next = 4;
              return request("/v1/winery-dashboards/".concat(_this3.id), "get", null, true, "api").catch(function (e) {
                _this.isLoading = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to get details of dashboard");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context2.sent;
              result = _objectSpread({}, response.data.value);
              _this3.form.wineryIds = result.configuration.wineries.map(function (x) {
                return x.id;
              });
              _this3.form.customTitle = result.customTitle;
              _this3.form.isShowTurnover = result.configuration.isShowTurnover;
              _this3.form.isActive = result.isActive;
              _this3.dbSyncedDashboard = _objectSpread({}, _this3.form);
              delete _this3.dbSyncedDashboard.valid;
              _this3.isLoading = false;
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    addDashboard: function addDashboard() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this4$form, valid, data, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.isAdding = true;
              _this4$form = _this4.form, valid = _this4$form.valid, data = _objectWithoutProperties(_this4$form, _excluded);
              _this = _this4;
              _context3.next = 5;
              return request("/v1/winery-dashboards", "post", data, true, "api").catch(function (e) {
                _this.isAdding = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to create the dashboard");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 5:
              _this4.isAdding = false;
              _this4.$emit("dashboardCreated");
              _this4.close();
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    checkChangeConfiguration: function checkChangeConfiguration() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this5$dbSyncedDashbo, _this5$dbSyncedDashbo2, data, _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!_this5.isEditingDashboard) {
                _context4.next = 11;
                break;
              }
              if (!(_this5.form.wineryIds !== ((_this5$dbSyncedDashbo = _this5.dbSyncedDashboard) === null || _this5$dbSyncedDashbo === void 0 ? void 0 : _this5$dbSyncedDashbo.wineryIds) || _this5.form.isShowTurnover !== ((_this5$dbSyncedDashbo2 = _this5.dbSyncedDashboard) === null || _this5$dbSyncedDashbo2 === void 0 ? void 0 : _this5$dbSyncedDashbo2.isShowTurnover))) {
                _context4.next = 11;
                break;
              }
              _this5.isUpdatingConfiguration = true;
              data = {
                wineryIds: _this5.form.wineryIds,
                isShowTurnover: _this5.form.isShowTurnover
              };
              _this = _this5;
              _context4.next = 7;
              return request("/v1/winery-dashboards/".concat(_this5.id, "/configuration"), "put", data, true, "api").catch(function (e) {
                var _this$dbSyncedDashboa;
                _this.isUpdatingConfiguration = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update or delete the winery configuration");
                handleErrorData(_this, errorData);
                _this.form.wineryIds = (_this$dbSyncedDashboa = _this.dbSyncedDashboard) === null || _this$dbSyncedDashboa === void 0 ? void 0 : _this$dbSyncedDashboa.wineryIds;
                throw e;
              });
            case 7:
              _this5.dbSyncedDashboard.wineryIds = _this5.form.wineryIds;
              _this5.dbSyncedDashboard.isShowTurnover = _this5.form.isShowTurnover;
              _this5.isUpdatingConfiguration = false;
              _this5.$emit("dashboardUpdated", _this5.id);
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    checkChangeCustomTitle: function checkChangeCustomTitle() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this6$dbSyncedDashbo, data, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!_this6.isEditingDashboard) {
                _context5.next = 10;
                break;
              }
              if (!(_this6.form.customTitle !== ((_this6$dbSyncedDashbo = _this6.dbSyncedDashboard) === null || _this6$dbSyncedDashbo === void 0 ? void 0 : _this6$dbSyncedDashbo.customTitle))) {
                _context5.next = 10;
                break;
              }
              _this6.isUpdatingCustomTitle = true;
              data = {
                customTitle: _this6.form.customTitle
              };
              _this = _this6;
              _context5.next = 7;
              return request("/v1/winery-dashboards/".concat(+_this6.id, "/custom-title"), "put", data, true, "api").catch(function (e) {
                var _this$dbSyncedDashboa2;
                _this.isUpdatingCustomTitle = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update the custom title");
                handleErrorData(_this, errorData);
                _this.form.customTitle = (_this$dbSyncedDashboa2 = _this.dbSyncedDashboard) === null || _this$dbSyncedDashboa2 === void 0 ? void 0 : _this$dbSyncedDashboa2.customTitle;
                throw e;
              });
            case 7:
              _this6.dbSyncedDashboard.customTitle = _this6.form.customTitle;
              _this6.isUpdatingCustomTitle = false;
              _this6.$emit("dashboardUpdated", _this6.id);
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    checkChangeActivationStatus: function checkChangeActivationStatus() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!_this7.isEditingDashboard) {
                _context6.next = 9;
                break;
              }
              _this7.isUpdatingActivationStatus = true;
              data = {
                isActive: _this7.form.isActive
              };
              _this = _this7;
              _context6.next = 6;
              return request("/v1/winery-dashboards/".concat(_this7.id, "/activation"), "put", data, true, "api").catch(function (e) {
                var _this$dbSyncedDashboa3;
                _this.isUpdatingActivationStatus = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to update the activation status");
                handleErrorData(_this, errorData);
                _this.form.isActive = (_this$dbSyncedDashboa3 = _this.dbSyncedDashboard) === null || _this$dbSyncedDashboa3 === void 0 ? void 0 : _this$dbSyncedDashboa3.isActive;
                throw e;
              });
            case 6:
              _this7.dbSyncedDashboard.isActive = _this7.form.isActive;
              _this7.isUpdatingActivationStatus = false;
              _this7.$emit("dashboardUpdated", _this7.id);
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    confirmDeleteDashboard: function confirmDeleteDashboard() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _this8.$refs.confirm.open("Delete the dashboard permanently ?", "Are you sure you want to permanently delete this dashboard? It cannot be undeleted or reactivated after this operation.", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7(confirm) {
                  return _regeneratorRuntime().wrap(function _callee7$(_context7) {
                    while (1) switch (_context7.prev = _context7.next) {
                      case 0:
                        if (!confirm) {
                          _context7.next = 3;
                          break;
                        }
                        _context7.next = 3;
                        return _this8.deleteDashboard();
                      case 3:
                      case "end":
                        return _context7.stop();
                    }
                  }, _callee7);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    deleteDashboard: function deleteDashboard() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this9.isDeletingDashboard = true;
              _this = _this9;
              _context9.next = 4;
              return request("/v1/winery-dashboards/".concat(_this9.id), "delete", null, true, "api").catch(function (e) {
                _this.isDeletingDashboard = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to delete the dashboard");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              _this9.isDeletingDashboard = false;
              _this9.$emit("dashboardDeleted", _this9.id);
              _this9.close();
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    addProducersOfRegion: function addProducersOfRegion() {
      var _this10 = this,
        _regionProducers$filt;
      var regionProducers = this.wineries.items.filter(function (winery) {
        return winery.regionSubs.some(function (subR) {
          return subR.regionParent.id == _this10.regionIdForProducers;
        });
      });
      var producerIdsToAdd = (_regionProducers$filt = regionProducers.filter(function (x) {
        return !_this10.form.wineryIds.includes(x.id);
      })) === null || _regionProducers$filt === void 0 ? void 0 : _regionProducers$filt.map(function (x) {
        return x.id;
      });
      this.form.wineryIds = [].concat(_toConsumableArray(this.form.wineryIds), _toConsumableArray(producerIdsToAdd));
      this.regionIdForProducers = null;
      this.checkChangeConfiguration();
    },
    getWineries: function getWineries() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this11.wineries.isLoading = true;
              _this = _this11;
              _context10.next = 4;
              return request("/v1/producers/all", "post", {}, true, "api").catch(function (e) {
                _this.wineries.isLoading = false;
                var errorData = getErrorData(e, _this.managedExceptions, "Unable to load the list of producers");
                handleErrorData(_this, errorData);
                throw e;
              });
            case 4:
              response = _context10.sent;
              _this11.wineries.items = _toConsumableArray(response.data.value.items);
              _this11.wineries.isLoading = false;
            case 7:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    getRegions: function getRegions() {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var _this12$gettingRegion;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _this12.gettingRegions.isPending = true;
              (_this12$gettingRegion = _this12.gettingRegions.cancellationToken) === null || _this12$gettingRegion === void 0 || _this12$gettingRegion.cancel();
              _this12.gettingRegions.cancellationToken = axios.CancelToken.source();
              _this = _this12;
              _context11.next = 6;
              return request("/v1/regions?variant=with-subregions", "get", null, true, "api", null, _this.gettingRegions.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of regions", true);
                  handleErrorData(_this, errorData);
                }
                _this.gettingRegions.isPending = false;
                throw e;
              });
            case 6:
              response = _context11.sent;
              _this12.gettingRegions.results = _toConsumableArray(response.data.value.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  displayName: "".concat(x.country.printable_name, " / ").concat(x.name)
                });
              }));
              _this12.gettingRegions.isPending = false;
            case 9:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    open: function open() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _this13.resetData();
              _this13.dialog = true;
              if (!(+_this13.id > 0)) {
                _context12.next = 5;
                break;
              }
              _context12.next = 5;
              return _this13.getDashboard();
            case 5:
              return _context12.abrupt("return", new Promise(function (resolve, reject) {
                _this13.resolve = resolve;
                _this13.reject = reject;
              }));
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    close: function close() {
      this.dialog = false;
      this.resetData();
    },
    resetData: function resetData() {
      this.form = _objectSpread({}, defaultForm);
      this.dbSyncedDashboard = null;
      this.isLoading = false;
      this.isAdding = false;
      this.isUpdatingConfiguration = false;
      this.isUpdatingCustomTitle = false;
      this.isUpdatingActivationStatus = false;
      this.isDeletingDashboard = false;
    }
  }
};